import ReactGABase from 'react-ga4'

// Vite 8 CJS interop: default export may be nested under .default

const ReactGA: typeof ReactGABase = (ReactGABase as any).default ?? ReactGABase

export default ReactGA
